<div class="turbo-table-row text">
    <div class="col-no column">
        {{ 'graph.cylinder.table.header.number' | translate }}
    </div>
    <div class="col-temp column">
        {{ 'graph.cylinder.table.header.temperature' | translate }}
    </div>
    <div class="col-options column"></div>
</div>
